export const THIS_PAGE_IS_BLOCKED =
  "You do not have access to this application.";
export const DONT_HAVE_PERMISION =
  "Please contact the Digital IT Helpdesk if you believe you should have access.";
